<div class="wrapper">
  <div
    *ngIf="!hideHeader"
    [class.active]="isSmallMenu"
    class="wrapper__menu">
    <app-menu [(isSmallMenu)]="isSmallMenu"/>
  </div>

  <app-mobile-menu [(isOpenMobileMenu)]="isOpenMobileMenu" />

  <div class="wrapper__content">
    <app-header
    *ngIf="!hideHeader"
    [(isOpenMobileMenu)]="isOpenMobileMenu"
    [headerTitle]="headerTitle"
    />

    <main
      [class.active]="hideHeader">
      <div
        class="container">
        <router-outlet />
      </div>
    </main>
  </div>
</div>

<app-notification />

<app-global-loader />




